import { FIELDS } from 'store/carInstance/constants';

import { AUTO_PARAMS as auto } from '../../constants';

export const DEFAULT_VALUE = {
  disabled: true,
  discount: 0,
  discountDirect: 0,
  id: null,
  loading: true,
  value: null,
};

export const FIELDS_NAME = {
  BANK: 'bank',
  BRAND: FIELDS.brand,
  FULL_CALCULATION: 'fullCalculation',
  IS_IN_CREDIT: 'isInCredit',
  IS_SET_DISCOUNT_DIRECT: 'isSetDiscountDirect',
  IS_SET_DISCOUNT_MFR: 'isSetDiscountMfr',
  MILEAGE: auto.mileage,
  MODEL: FIELDS.model,
  OFFER_PRICE: FIELDS.offerPrice,
  PRICE: FIELDS.price,
  VERSION: FIELDS.version,
  YEAR: FIELDS.year,
};

export const DEFAULT_DISABLED = Object.values(FIELDS_NAME).reduce((acc, field) => {
  acc[field] = true;

  return acc;
}, {});
